import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import location from '../Assets/location.svg'
import email from '../Assets/email.svg'
import call from '../Assets/call.svg'
import { toast } from 'react-toastify'
import { Create_Api } from '../ApiUrls'
import WhatsAppButton from '../Components/WhatsAppButton'

function ContactUs() {

    const [IsUploading, setIsUploading] = useState(false);
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');
    const [Message, setMessage] = useState('');

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhoneNumber = (number) => /^[6-9]\d{9}$/.test(number);
    const isValidName = (name) => /^[A-Za-z]{2,}$/.test(name);

    const SendContactUs = async () => {
        if (!FirstName.trim() || !isValidName(FirstName)) return toast.error('First Name must contain at least 2 letters and no numbers!');
        if (!LastName.trim() || !isValidName(LastName)) return toast.error('Last Name must contain at least 2 letters and no numbers!');
        if (!Email.trim() || !isValidEmail(Email)) return toast.error('Enter a valid email address!');
        if (!Number.trim() || !isValidPhoneNumber(Number)) return toast.error('Enter a valid 10-digit mobile number!');
        if (!Message.trim() || Message.length < 10) return toast.error('Message should be at least 10 characters long!');

        try {
            let data = {
                FirstName,
                LastName,
                Email,
                Number,
                Message
            }
            setIsUploading(true)
            const response = await Create_Api(`api/admin/CreateContactUs`, data)
            toast.success(response?.message);
            setFirstName('')
            setLastName('')
            setEmail('')
            setNumber('')
            setMessage('')
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error)
        }
    }


    return (
        <>
            <Navbar />
            <div className="ContactUs-header">
                <h1>Contact US</h1>
                <p>
                    Home / <span className="active">Contact US</span>
                </p>
            </div>
            <br />
            <br />
            <br />
            <div className="contact-container">
                {/* Contact Info Section */}
                <h2 className="contact-heading">Got An Idea? Let's Collaborate!</h2>
                <div className="contact-info">
                    <div className="contact-card">
                        <img src={email} alt="Email" className="contact-icon" />
                        <h3>Support Email</h3>
                        <p>contact@adlrealtors.com</p>
                        <button className="contact-buttonadded">Email Us</button>
                    </div>
                    <div className="contact-card">
                        <img src={call} alt="Phone" className="contact-icon" />
                        <h3>Phone Number</h3>
                        <p>+91 9922555897</p>
                        <button className="contact-buttonadded">Call Us</button>
                    </div>
                    <div className="contact-card">
                        <img src={location} alt="Location" className="contact-icon" />
                        <h3>Address</h3>
                        <p>Runwal Platinum, Bavdhan, Pune - 411021</p>
                        <button className="contact-buttonadded">Visit Us</button>
                    </div>
                </div>
                <br />
                <br />
                <div className="contact-form-map">
                    <div className="contact-form-container">
                        <h2>Send Us a Message</h2>
                        <div className="contact-form">
                            <div className="input-group">
                                <label>First Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter your first name"
                                    value={FirstName}
                                    onChange={(e) => { setFirstName(e.target.value) }}
                                />
                            </div>
                            <div className="input-group">
                                <label>last Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter your last name"
                                    value={LastName}
                                    onChange={(e) => { setLastName(e.target.value) }}
                                />
                            </div>
                            <div className="input-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={Email}
                                    onChange={(e) => { setEmail(e.target.value) }}
                                />
                            </div>
                            <div className="input-group">
                                <label>Phone Number</label>
                                <input
                                    type="number"
                                    placeholder="Enter your phone number"
                                    value={Number}
                                    onChange={(e) => { setNumber(e.target.value) }}
                                />
                            </div>
                            <div className="input-group">
                                <label>Message</label>
                                <textarea
                                    placeholder="Enter your message"
                                    value={Message}
                                    onChange={(e) => { setMessage(e.target.value) }}
                                ></textarea>
                            </div>
                            <button className="form-submit-button" onClick={() => { SendContactUs() }}>{IsUploading ? "Please Wait" : "Send"}</button>
                        </div>
                    </div>

                    {/* Map Section */}
                    <div className="map-container">
                        <iframe
                            className="map"
                            src="https://maps.google.com/maps?q=40.7128,-74.0060&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            allowFullScreen
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            </div>
            <WhatsAppButton />
            <Footer />
        </>
    )
}

export default ContactUs
